export function isAgentActive(agent) {
  if (!agent) return false
  return agent.hasAcceptedInvitation && !agent.archived
}

export function isAgentNotArchived(agent) {
  if (!agent) return false
  return !agent.archived
}
